const monsters_ = [
  { lat: 85.04523142802671, lng: -179.93785858154297 },
  { lat: 85.01384928049275, lng: -179.76207733154297 },
  { lat: 85.01845846442565, lng: -179.64847773313528 },
  { lat: 85.01268538977108, lng: -179.4273376464844 },
  { lat: 85.02533002426063, lng: -179.26815524697304 },
  { lat: 85.04000983840967, lng: -179.31987762451175 },
  { lat: 85.04600233423471, lng: -179.14306640625003 },
  { lat: 85.04009888874582, lng: -179.72190856933597 },
  { lat: 85.0451721225929, lng: -179.93785858154297 },
];

const phones = [
  { lat: 85.04457902930932, lng: -179.87571716308594 },
  { lat: 85.03730788685448, lng: -179.879150390625 },
  { lat: 85.01813319628694, lng: -179.82505157589915 },
  { lat: 85.02045817079237, lng: -179.7237713634968 },
  { lat: 85.01044637665916, lng: -179.49600219726562 },
  { lat: 85.02422277951345, lng: -179.48501586914062 },
  { lat: 85.01275884040457, lng: -179.30322244763377 },
  { lat: 85.03423451262329, lng: -179.3198870122433 },
];

const homes = [
  { lat: 85.01888967699189, lng: -179.94987487792972 },
  { lat: 85.025503067195, lng: -179.87537384033206 },
  { lat: 85.01808474780562, lng: -179.76860046386722 },
  { lat: 85.03736728618173, lng: -179.5475006103516 },
  { lat: 85.02514441508455, lng: -179.37150210142136 },
  { lat: 85.0374563838429, lng: -179.10427093505862 },
];

const moneyBag = [
  { lat: 85.0225520261357, lng: -179.7738001014657 },
  { lat: 85.0308479925631, lng: -179.66085539669692 },
  { lat: 85.03512525126912, lng: -179.6382043982131 },
];

const seaShell = [
  { lat: 85.04303790475231, lng: -179.81385954474683 },
  { lat: 85.03802265689117, lng: -179.87018248692675 },
  { lat: 85.0343990366048, lng: -179.94127302980021 },
  { lat: 85.03134375770176, lng: -179.82939278375872 },
  { lat: 85.02649526984702, lng: -179.8860591585129 },
  { lat: 85.0246498210538, lng: -179.89086721455266 },
  { lat: 85.0246498210538, lng: -179.86991782752233 },
  { lat: 85.01961601566491, lng: -179.88090766989887 },
  { lat: 85.01827479705634, lng: -179.77890819534133 },
  { lat: 85.02056955198034, lng: -179.76723148781622 },
  { lat: 85.0183046058281, lng: -179.75967597118236 },
  { lat: 85.01937760312845, lng: -179.70094900098252 },
  { lat: 85.02667382542616, lng: -179.7043833267252 },
  { lat: 85.00865636133997, lng: -179.91242645068752 },
  { lat: 85.01161224854634, lng: -179.83309352603163 },
  { lat: 85.01262699887633, lng: -179.76131611800966 },
  { lat: 85.00602743938782, lng: -179.68242216964265 },
  { lat: 85.00722257508313, lng: -179.59175597003593 },
  { lat: 85.00716282507456, lng: -179.4904433606269 },
  { lat: 85.00865636133997, lng: -179.4457971259721 },
  { lat: 85.0163261085114, lng: -179.4330901207242 },
  { lat: 85.01411890474262, lng: -179.60824073360078 },
  { lat: 85.01871117837484, lng: -179.49422111894384 },
  { lat: 85.01891981780939, lng: -179.59141253746165 },
  { lat: 85.01957548500039, lng: -179.6539172659784 },
  { lat: 85.0210102600795, lng: -179.5406986725857 },
  { lat: 85.02520924024311, lng: -179.50154735911917 },
  { lat: 85.03451776121017, lng: -179.48368886525725 },
  { lat: 85.03294278074631, lng: -179.52867853248634 },
  { lat: 85.03733959279208, lng: -179.5472238914968 },
  { lat: 85.03837893604472, lng: -179.64807737473083 },
  { lat: 85.04449108407525, lng: -179.64876423987934 },
  { lat: 85.0448518485879, lng: -179.40924953306433 },
  { lat: 85.04523728663546, lng: -179.2389069762275 },
  { lat: 85.04129254634952, lng: -179.25127054890112 },
  { lat: 85.03814637476918, lng: -179.23169489216784 },
  { lat: 85.04194527595573, lng: -179.20078596048376 },
  { lat: 85.04461464107736, lng: -179.14102869256115 },
  { lat: 85.02888951264123, lng: -179.26840266526088 },
  { lat: 85.03061445338183, lng: -179.1547264831782 },
  { lat: 85.01936185499864, lng: -179.14820126426707 },
  { lat: 85.02362177607861, lng: -179.31957411882675 },
  { lat: 85.01515795178655, lng: -179.21723121169495 },
  { lat: 85.01506846859422, lng: -179.1973121223874 },
  { lat: 85.0117913370975, lng: -179.3809809480003 },
  { lat: 85.00734207296055, lng: -179.18213348749921 },
  { lat: 85.00719270016799, lng: -179.0873706967623 },
  { lat: 85.01417857171714, lng: -179.0987039717131 },
  { lat: 85.0227357091262, lng: -179.11003724666395 },
  { lat: 85.03825941412963, lng: -179.1021382974558 },
];

var hearts = [
  { lat: 85.04656631740812, lng: -179.94333424107683 },
  { lat: 85.04087217573034, lng: -179.86468903626826 },
  { lat: 85.03389168183678, lng: -179.83652787122764 },
  { lat: 85.03374310137288, lng: -179.71701463422596 },
  { lat: 85.03190033518396, lng: -179.92032450866557 },
  { lat: 85.02479038429773, lng: -179.89147648594104 },
  { lat: 85.02467130298872, lng: -179.87052732658154 },
  { lat: 85.0226167028393, lng: -179.77196324893936 },
  { lat: 85.01874098454203, lng: -179.93955652381527 },
  { lat: 85.01850253022316, lng: -179.7774581104107 },
  { lat: 85.01844291486437, lng: -179.7575392375771 },
  { lat: 85.01029873652313, lng: -179.5361203554716 },
  { lat: 85.0079992602938, lng: -179.4221019799413 },
  { lat: 85.01608753888331, lng: -179.5471100784143 },
  { lat: 85.02344620026466, lng: -179.6884234798752 },
  { lat: 85.02689925214611, lng: -179.66575717630596 },
  { lat: 85.0240714989667, lng: -179.62042456916737 },
  { lat: 85.02526232731427, lng: -179.456609011553 },
  { lat: 85.03468959416325, lng: -179.5407490778329 },
  { lat: 85.03751788440573, lng: -179.55088418868203 },
  { lat: 85.03751788440573, lng: -179.53027845816453 },
  { lat: 85.04235565359028, lng: -179.5529447617338 },
  { lat: 85.04484689994307, lng: -179.55328819057576 },
  { lat: 85.03892973059799, lng: -179.1445478851288 },
  { lat: 85.03180542858068, lng: -179.26106490251996 },
  { lat: 85.02478465303079, lng: -179.37130556078873 },
  { lat: 85.02573720225622, lng: -179.11613793121336 },
  { lat: 85.01852903215766, lng: -179.35482097637467 },
  { lat: 85.01470935274148, lng: -179.29160982090318 },
  { lat: 85.01509712953313, lng: -179.18342973568616 },
  { lat: 85.01516327772488, lng: -179.08771357424055 },
  { lat: 85.03781438952582, lng: -179.1052283390924 },
];

var names = [
  { lat: 85.03724848681803, lng: -179.8095144357091 },
  { lat: 85.03053171272774, lng: -179.84967085196502 },
  { lat: 85.0204403712627, lng: -179.84563195351743 },
  { lat: 85.00835572649035, lng: -179.77072993869646 },
  { lat: 85.01432033825162, lng: -179.57136775898195 },
  { lat: 85.02171445607772, lng: -179.5480289871409 },
  { lat: 85.0274630180443, lng: -179.57263288024302 },
  { lat: 85.03451082206811, lng: -179.58430226616355 },
  { lat: 85.03305449870203, lng: -179.69275891177782 },
  { lat: 85.04598039217436, lng: -179.59722435099292 },
  { lat: 85.04310603556193, lng: -179.32866494178072 },
  { lat: 85.03743674556539, lng: -179.3314106796444 },
  { lat: 85.03046526097906, lng: -179.17436953358884 },
  { lat: 85.03082718424574, lng: -179.42440303641794 },
  { lat: 85.01817734592305, lng: -179.17330744865748 },
  { lat: 85.01367339599756, lng: -179.24469663311245 },
  { lat: 85.01101684778217, lng: -179.12182486371404 },
  { lat: 85.00829598079096, lng: -179.4249927402922 },
];

const monsters = [
  ...monsters_.map(({ lat, lng }: any, i: number) => {
    return {
      id: `monster_${i}`,
      type: 'monster',
      position: [lat, lng],
    };
  }),
  ...phones.map(({ lat, lng }: any, i: number) => {
    return {
      id: `phone_${i}`,
      type: 'phone',
      position: [lat, lng],
    };
  }),
  ...hearts.map(({ lat, lng }: any, i: number) => {
    return {
      id: `heart_${i}`,
      type: 'heart',
      position: [lat, lng],
    };
  }),
  ...seaShell.map(({ lat, lng }: any, i: number) => {
    return {
      id: `seashell_${i}`,
      type: 'seashell',
      position: [lat, lng],
    };
  }),
  ...moneyBag.map(({ lat, lng }: any, i: number) => {
    return {
      id: `moneyBag_${i}`,
      type: 'moneyBag',
      position: [lat, lng],
    };
  }),
  ...homes.map(({ lat, lng }: any, i: number) => {
    return {
      id: `house_${i}`,
      type: 'house',
      position: [lat, lng],
    };
  }),
];
export {
  monsters,
  hearts,
  // seashell,
};
